import Vue from 'vue'

import 'normalize.css/normalize.css'// A modern alternative to CSS resets

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n
import VCharts from 'v-charts'
import echarts from 'echarts'

import '@/styles/index.scss' // global css

import App from './App'
import router from './router'
import store from './store'
import JlFilterHeader from '@/components/JlFilterHeader'
import { GlobalMessage, GlobalNotification } from '@/utils/globalFeedback'
import MobileColumnMove from '@/components/MobileColumnMove'
import installMobileTableSupport from '@/utils/mobileTableSupport'
import installMobilePopoverSupport from '@/utils/mobilePopoverSupport'

import '@/icons' // icon
import '@/permission' // permission control

//import '@/assets/styles/jlcommon.scss' // permission control
import '@/assets/styles/jl-theme.scss'

import '@/assets/css/common-modules.css';
import '@/assets/styles/jl-enterprise-theme.scss';
// 移动端覆盖层必须最后加载，确保只在窄屏覆盖页面及组件中的桌面固定尺寸。
import '@/assets/css/mobile-responsive.css';

// 手机浏览器的地址栏和软键盘会动态改变实际可视高度。
// 将 Visual Viewport 同步为 CSS 变量，避免 Chrome / Safari 对 100vh 的解释差异导致页面底部被裁切。
let lastMobileChartWidth = null

function resizeMobileCharts(width, height) {
  const isMobileViewport = width <= 768 || (width <= 960 && height <= 540 && width > height)
  if (!isMobileViewport) {
    lastMobileChartWidth = null
    return
  }
  const roundedWidth = Math.round(width)
  if (lastMobileChartWidth === roundedWidth) return
  lastMobileChartWidth = roundedWidth

  window.requestAnimationFrame(() => {
    document.querySelectorAll('[_echarts_instance_]').forEach(container => {
      const chart = echarts.getInstanceByDom(container)
      if (chart) chart.resize()
    })
  })
}

function syncVisibleViewport() {
  const viewport = window.visualViewport
  const height = viewport && viewport.height ? viewport.height : window.innerHeight
  const width = viewport && viewport.width ? viewport.width : window.innerWidth

  document.documentElement.style.setProperty('--app-viewport-height', `${Math.round(height)}px`)
  document.documentElement.style.setProperty('--app-viewport-width', `${Math.round(width)}px`)
  document.documentElement.style.setProperty('--app-viewport-top', `${Math.round(viewport ? viewport.offsetTop : 0)}px`)
  resizeMobileCharts(width, height)
}

let viewportFrame = null
function scheduleVisibleViewportSync() {
  if (viewportFrame !== null) return
  viewportFrame = window.requestAnimationFrame(() => {
    viewportFrame = null
    syncVisibleViewport()
  })
}

syncVisibleViewport()
window.addEventListener('resize', scheduleVisibleViewportSync, { passive: true })
window.addEventListener('orientationchange', scheduleVisibleViewportSync, { passive: true })
if (window.visualViewport) {
  window.visualViewport.addEventListener('resize', scheduleVisibleViewportSync, { passive: true })
  window.visualViewport.addEventListener('scroll', scheduleVisibleViewportSync, { passive: true })
}


Vue.use(ElementUI, { locale })
installMobileTableSupport(Vue)
installMobilePopoverSupport(Vue)
Vue.component('jl-mobile-column-move', MobileColumnMove)
Vue.use(VCharts)
Vue.component('jl-filter-header', JlFilterHeader)
// 操作反馈统一放在右下角，避免遮挡固定的多级顶部导航。
Vue.prototype.$message = GlobalMessage
Vue.prototype.$notify = GlobalNotification

Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js